import React from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/system";

import { checkIsShowSmallMenu } from "./FormNavigation/utils";

const StyledFooter = styled("div")(({ theme, smallMenu }) => ({
  width: "100%",
  zIndex: 1,
  display: "flex",
  flexDirection: "column-reverse",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "1.5rem",
  background: "#FFFFFF",
  padding: "3rem 0.9375rem 2rem 0.9375rem",
  "& .back-link": {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto"
    },
    "& .linkContainerBtn": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
      textAlign: "center",
      padding: "1rem 1.625rem",
      borderRadius: "6.25rem",
      background: "#FFF",
      color: "#000",
      fontWeight: 500,
      lineHeight: "1.5rem",
      [theme.breakpoints.up("sm")]: {
        minWidth: "9rem"
      },
      [theme.breakpoints.only("md")]: {
        fontSize: "1.125rem"
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "1.25rem"
      },
      "&:hover": {
        "& svg": {
          fill: "#3B3A3A"
        }
      },
      "& svg": {
        display: "none",
        [theme.breakpoints.up("sm")]: {
          display: "block"
        }
      }
    }
  },
  "& .footerCTA": {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto"
    },
    button: {
      "& svg": {
        display: "none",
        "&.btnLoader": {
          display: "block"
        },
        [theme.breakpoints.up("sm")]: {
          display: "block"
        }
      }
    }
  },
  button: {
    width: "100%",
    minWidth: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      minWidth: "auto"
    }
  },
  [theme.breakpoints.up("sm")]: {
    position: "fixed",
    bottom: "0px",
    right: "0px",
    margin: "0px",
    flexDirection: "row",
    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.10)",
    padding: "1.5rem 5.125rem",
    alignItems: "flex-end"
  }
}));

export const Footer = ({ children, extraClasses, dataTestId, hideSaveClose = false }) => {
  const { pathname } = useLocation();

  return (
    <StyledFooter
      data-testid={dataTestId}
      smallMenu={checkIsShowSmallMenu(pathname)}
      className={extraClasses}
    >
      {children}
    </StyledFooter>
  );
};
